import type React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const UpArrowIcon: React.FC<IconProps> = ({ size = 18, className }) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 8 8"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.016"
      y="1.68"
      transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 6.2428 2.2389)"
      width="5.283"
      height="1.466"
    />
    <rect x="3.161" y="1.604" width="1.683" height="6.375" />
    <rect
      x="2.709"
      y="1.674"
      transform="matrix(0.7073 0.7069 -0.7069 0.7073 3.2674 -3.0786)"
      width="5.284"
      height="1.465"
    />
  </svg>
);

export const DownArrowIcon: React.FC<IconProps> = ({
  size = 18,
  className,
}) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 8 8"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.709"
      y="4.855"
      transform="matrix(0.7071 -0.7072 0.7072 0.7071 -2.3841 5.4202)"
      width="5.283"
      height="1.466"
    />
    <rect x="3.164" y="0.021" width="1.683" height="6.375" />
    <rect
      x="0.015"
      y="4.861"
      transform="matrix(-0.7073 -0.7069 0.7069 -0.7073 0.5815 11.4283)"
      width="5.284"
      height="1.465"
    />
  </svg>
);

export const CloseIcon: React.FC<IconProps> = ({ size = 18, className }) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.1 3.1l-2.2-2.2-4.9 5-4.9-5-2.2 2.2 5 4.9-5 4.9 2.2 2.2 4.9-5 4.9 5 2.2-2.2-5-4.9z" />
  </svg>
);
